import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';
import './index.less';

import TablePropTypes from '../../prop-types';

import withIntl, { IntlPropType } from '../../../intl-hoc';

function TableHeadItem({ className, intl, items, renderTH }) {
	return (
		<tr className={cn('new-table__head__item', className)}>
			{items.map((item) => renderTH(item, { intl }))}
		</tr>
	);
}

TableHeadItem.propTypes = {
	className: PropTypes.string,
	intl: IntlPropType,
	items: TablePropTypes.HeaderItemsPropType,
	renderTH: TablePropTypes.RenderPropType
};

export default withIntl(TableHeadItem);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/new-table/components/TableHeadItem/index.js